export const bonuses = [
  {
    number: 1,
    color: "#1C4FA0",
    image: "https://cdn.magicpatterns.com/uploads/17oMAenqkskyuJaUgFxp52/BONUS_1_NUTRITION-EN.png",
    title: "The Renal Nutrient Comparison Atlas",
    shortTitle: "Renal Nutrient Comparison Atlas",
    tagline: "Organize your study of key nutrients and their relevance to renal nutrition.",
    body: [
      "Understanding the roles of protein, sodium, potassium, phosphorus, and fluid balance requires studying how these factors relate to kidney function and individual nutritional circumstances.",
      "This atlas organizes relevant educational concepts into visual reference materials.",
    ],
    items: [
      "Protein and energy reference tables",
      "Sodium content comparison charts",
      "Potassium food-source reference tables",
      "Phosphorus source comparison materials",
      "Fluid balance educational diagrams",
      "Nutrient terminology reference sheets",
      "Food label interpretation exercises",
      "Nutrient comparison worksheets",
    ],
    note: "",
    value: 19,
  },
  {
    number: 2,
    color: "#1D7A55",
    image: "https://cdn.magicpatterns.com/uploads/qBAZH11LccRERYxv3RgyR4/BONUS_2_NUTRITION-EN.png",
    title: "The Renal Nutrition Assessment Toolkit",
    shortTitle: "Renal Nutrition Assessment Toolkit",
    tagline: "Organize the information you review during renal nutrition assessment.",
    body: [
      "This toolkit provides educational worksheets for organizing dietary histories, nutritional observations, and relevant assessment information.",
    ],
    items: [
      "Renal nutrition consultation preparation checklist",
      "Dietary history assessment worksheet",
      "Nutritional status review template",
      "Weight trend documentation form",
      "Dietary intake recording worksheet",
      "Nutrition risk review framework",
      "Relevant laboratory information organizer",
      "Nutrition assessment summary template",
    ],
    note: "The materials are designed for educational use and professional adaptation.",
    value: 17,
  },
  {
    number: 3,
    color: "#9A6A0B",
    image: "https://cdn.magicpatterns.com/uploads/1qYMaP6UG5E3tN6kyR5qtB/BONUS_3_NUTRITION-EN.png",
    title: "The CKD Stage & Nutrition Considerations Reference",
    shortTitle: "CKD Stage & Nutrition Considerations Reference",
    tagline: "Study how renal nutrition considerations can differ across kidney disease contexts.",
    body: [
      "Chronic kidney disease involves different clinical circumstances, and nutritional considerations cannot be reduced to a single dietary approach.",
      "This reference organizes educational information about kidney disease classification and the nutrition-related topics commonly considered in different clinical contexts.",
    ],
    items: [
      "CKD classification educational reference",
      "Kidney function terminology guide",
      "Nutrition considerations across CKD stages",
      "Protein and energy education reference",
      "Electrolyte-related considerations",
      "Fluid balance educational overview",
      "Comorbidity review worksheet",
      "Clinical discussion preparation checklist",
    ],
    note: "The resource supports educational review and does not establish treatment recommendations based on CKD stage alone.",
    value: 19,
  },
  {
    number: 4,
    color: "#A3222A",
    image: "https://cdn.magicpatterns.com/uploads/v2mXmnG4uZpamYr33dAxcX/BONUS_4_NUTRITION-EN.png",
    title: "The Renal Nutrition Clinical Casebook",
    shortTitle: "Renal Nutrition Clinical Casebook",
    tagline: "Study hypothetical cases using a structured educational framework.",
    body: [
      "Case-based learning gives you an opportunity to organize information, identify relevant nutritional considerations, and review the reasoning involved in different clinical scenarios.",
      "This casebook contains hypothetical educational cases developed around renal nutrition topics.",
    ],
    items: [
      "Chronic kidney disease nutrition scenarios",
      "Hemodialysis nutrition case exercises",
      "Peritoneal dialysis educational cases",
      "Acute kidney injury nutrition scenarios",
      "Kidney transplant nutrition case discussions",
      "Diabetes and kidney disease case exercises",
      "Nutrition assessment analysis worksheets",
      "Structured case review questions",
    ],
    note: "The cases are educational examples, not validated clinical protocols or individualized treatment recommendations.",
    value: 17,
  },
  {
    number: 5,
    color: "#1D6B4A",
    image: "https://cdn.magicpatterns.com/uploads/6DybBDAaC4f2DfY5fMG25p/BONUS_5_NUTRITION-EN.png",
    title: "The Renal Nutrition Documentation & Monitoring Toolkit",
    shortTitle: "Renal Nutrition Documentation & Monitoring Toolkit",
    tagline: "Keep your educational documentation resources organized in one place.",
    body: [
      "This practical resource complements Volume VI with additional templates for organizing nutrition assessment, monitoring, and follow-up information.",
    ],
    items: [
      "Nutrition consultation record templates",
      "Dietary intake monitoring forms",
      "Nutrition care plan review worksheets",
      "Weight trend tracking sheets",
      "Nutrition counseling documentation templates",
      "Follow-up assessment forms",
      "Nutrition intervention monitoring records",
      "Clinical case review documentation checklist",
    ],
    note: "Adapt all materials to your professional scope, privacy requirements, and applicable documentation standards.",
    value: 19,
  },
];
